import ClearIcon from '@mui/icons-material/Clear';
import React from 'react';

import { PermissionItemProps } from './PermissionItem.props';
import { Root, PermissionTitle } from './PermissionItem.styles';
import { ColorProps, FontSizeProps } from '../../../@types';
import { Button, ButtonVariantProps, ButtonSizeProps } from '../../atoms/Button';
import { VerticalAlignProps } from '../../atoms/InlineGroup';
import { TypographyVariantProps } from '../../atoms/Typography';

export const PermissionItem: React.FC<PermissionItemProps> = ({
  permission,
  onRemovePermission
}) => {
  return (
    <Root childGap={8} vertical={VerticalAlignProps.Center}>
      <PermissionTitle {...permission} variant={TypographyVariantProps.Subtitle2}> 
        {permission.name}
      </PermissionTitle>
      <Button variant={ButtonVariantProps.Icon} size={ButtonSizeProps.Medium}>
        <ClearIcon fontSize={FontSizeProps.Small} color={ColorProps.Primary} onClick={() => onRemovePermission(permission)} />
      </Button>
    </Root>
  );
};
